/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cus_Modal_IntroInputs */

const en_cus_modal_intro = /** @type {(inputs: Cus_Modal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You went on site without reaching the customer first and were unable to do the work.`)
};

const ja_cus_modal_intro = /** @type {(inputs: Cus_Modal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事前に顧客に連絡せずに現場に向かい、作業を実施できませんでした。`)
};

const fr_cus_modal_intro = /** @type {(inputs: Cus_Modal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes allé sur site sans avoir joint le client au préalable et n'avez pas pu effectuer le travail.`)
};

const de_cus_modal_intro = /** @type {(inputs: Cus_Modal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie waren vor Ort, ohne den Kunden vorab erreicht zu haben, und konnten die Arbeit nicht ausführen.`)
};

/**
* | output |
* | --- |
* | "You went on site without reaching the customer first and were unable to do the work." |
*
* @param {Cus_Modal_IntroInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cus_modal_intro = /** @type {((inputs?: Cus_Modal_IntroInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cus_Modal_IntroInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cus_modal_intro(inputs)
	if (locale === "ja") return ja_cus_modal_intro(inputs)
	if (locale === "fr") return fr_cus_modal_intro(inputs)
	return de_cus_modal_intro(inputs)
});